import CreateOrderPage from "./CreateOrderPage"
export default CreateOrderPage
